import ProjectSiteContact from "../ProjectSiteContact";

describe("ProjectSiteContact model", () => {
  test("belongsTo relations", () => {
    expect(
      ProjectSiteContact.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
